import { cooperationTypes } from "@/mocks/homeContent";

export default function Cooperation() {
  return (
    <section id="cooperation" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-5 lg:gap-12">
          <div className="lg:col-span-2">
            <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-700">
              <span className="h-px w-6 bg-primary-600"></span> 合作入口
            </span>
            <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              与机构同行，
              <br className="hidden md:block" />
              让选题走得更远
            </h2>
            <p className="mt-5 text-base leading-relaxed text-foreground-600">
              无论你是媒体机构、内容团队、独立作者还是行业专家，我们都期待以开放、授权清晰、对等回应为原则展开合作。
            </p>
            <ul className="mt-6 space-y-3">
              {cooperationTypes.map((c) => (
                <li key={c.title} className="flex items-start gap-3">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                    <i className={`${c.icon} text-xl`}></i>
                  </span>
                  <div>
                    <p className="font-display text-sm font-bold text-foreground-950">{c.title}</p>
                    <p className="mt-0.5 text-sm text-foreground-600">{c.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <img
              src="https://readdy.ai/api/search-image?query=Editorial%20newsroom%20team%20collaboration%20around%20a%20large%20wooden%20table%20with%20printouts%20and%20digital%20tablets%2C%20warm%20lamplight%20and%20crimson%20detail%20accents%2C%20documented%20and%20thoughtful%20atmosphere%2C%20papers%20with%20charts%20and%20notes%2C%20soft%20natural%20light%20through%20windows%2C%20stylized%20professional%20photography%2C%20warm%20neutral%20tones&width=1200&height=760&seq=cooperation-office-02&orientation=landscape"
              alt="曝光导航编辑部与合作伙伴围绕选题进行协作"
              className="h-[360px] w-full rounded-lg object-cover object-top md:h-[460px]"
            />
          </div>
        </div>
      </div>
    </section>
  );
}